<template>
  <b-row>
    <b-col>
      <form @submit.prevent="handleSubmit(item)">
        <b-row>
          <b-col sm="12" lg="4">
            <div class="form-group">
              <label
                      for="excmdevicemodel_model"
                      class="form-control-label">{{$t('views.excmdevicemodel.form.model')}}:</label>
              <input
                      id="excmdevicemodel_model"
                      v-model="item.model"
                      :class="['form-control', isInvalid('model') ? 'is-invalid' : '']"
                      type="text"
                      placeholder=""
                      @input="handleUpdateField('model', $event.target.value)">
              <div
                      v-if="isInvalid('model')"
                      class="invalid-feedback">{{ violations.model }}</div>
            </div>
          </b-col>
          <b-col sm="12" lg="4">
            <div class="form-group">
              <label
                      for="excmdevicemodel_idDeviceBrand"
                      class="form-control-label">{{$t('views.excmdevicemodel.form.idDeviceBrand')}}:</label>
              <b-row>
                <b-col class="pr-0">
                  <fg-input :error="violations.idDeviceBrand">
                    <el-select
                            id="excmdevicemodel_idDeviceBrand"
                            :class="['select-default', isInvalid('idDeviceBrand') ? 'select-danger' : '']"
                            :placeholder="$t('views.excmdevicemodel.form.idDeviceBrand')"
                            filterable
                            v-model="item.idDeviceBrand">
                      <el-option v-for="option in deviceBrands"
                                 class="select-default"
                                 :value="option['@id']"
                                 :label="option['brandTitle']"
                                 :key="option['@id']">
                      </el-option>
                    </el-select>
                  </fg-input>
                </b-col>
                <b-col class="pl-0" cols="3" v-if="ableToCreateDeviceBrand">
                  <b-btn class="m-0 w-100" style="padding-top: 13px; padding-bottom: 13px;" @click="addNewDeviceBrand()" variant="success" v-b-tooltip.hover :title="$t('views.excmdevicemodel.form.addNewDeviceBrand')">
                    <i class="fas fa-plus"></i>
                  </b-btn>
                </b-col>
              </b-row>
            </div>
          </b-col>
          <b-col sm="12" lg="4">
            <div class="form-group">
              <label
                      for="excmdevicemodel_idDeviceBrand"
                      class="form-control-label">{{$t('views.excmdevicemodel.form.idDeviceType')}}:</label>
              <b-row>
                <b-col class="pr-0">
                  <fg-input :error="violations.idDeviceType">
                    <el-select
                            id="excmdevicemodel_idDeviceBrand"
                            :class="['select-default', isInvalid('idDeviceType') ? 'select-danger' : '']"
                            :placeholder="$t('views.excmdevicemodel.form.idDeviceType')"
                            filterable
                            v-model="item.idDeviceType">
                      <el-option v-for="option in deviceTypes"
                                 class="select-default"
                                 :value="option['@id']"
                                 :label="option['title']"
                                 :key="option['@id']">
                      </el-option>
                    </el-select>
                  </fg-input>
                </b-col>
                <b-col class="pl-0" cols="3" v-if="ableToCreateDeviceType">
                  <b-btn class="m-0 w-100" style="padding-top: 13px; padding-bottom: 13px;" @click="addNewDeviceType()" variant="success" v-b-tooltip.hover :title="$t('views.excmdevicemodel.form.addNewDeviceType')">
                    <i class="fas fa-plus"></i>
                  </b-btn>
                </b-col>
              </b-row>
            </div>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <button
                    type="submit"
                    class="btn btn-success">{{$t('buttons.submit')}}</button>
            <b-btn v-if="openedInModal" @click="closeModal()" variant="danger">{{$t('buttons.close')}}</b-btn>
          </b-col>
        </b-row>
      </form>
      <DeviceTypeCreateModal v-if="ableToCreateDeviceType"></DeviceTypeCreateModal>
      <DeviceBrandCreateModal v-if="ableToCreateDeviceBrand"></DeviceBrandCreateModal>
    </b-col>
  </b-row>
</template>

<script>
import DeviceTypeCreateModal from '../excmdevicetype/components/DeviceTypeCreateModal/DeviceTypeCreateModal'
import DeviceBrandCreateModal from '../excmdevicebrand/components/DeviceBrandCreateModal/DeviceBrandCreateModal'
import { checkPermission } from '@/utils/checkRoles.js'
export default {
  components: {
    DeviceTypeCreateModal,
    DeviceBrandCreateModal
  },

  props: {
    handleSubmit: {
      type: Function,
      required: true
    },

    handleUpdateField: {
      type: Function,
      required: true
    },

    values: {
      type: Object,
      required: true
    },

    errors: {
      type: Object,
      default: () => {}
    },

    initialValues: {
      type: Object,
      default: () => {}
    },

    openedInModal: {
      type: Boolean,
      default: false
    }
  },

  data () {
    return {
      deviceBrands: [],
      deviceTypes: []
    }
  },

  computed: {
    // eslint-disable-next-line
    item () {
      return this.initialValues || this.values
    },

    violations () {
      return this.errors || {}
    },

    ableToCreateDeviceType () {
      return this.checkRoles('devices', 'EXCMDeviceTypeCreate')
    },

    ableToCreateDeviceBrand () {
      return this.checkRoles('devices', 'EXCMDeviceBrandCreate')
    }
  },

  created () {
    this.getDeviceBrands()
    this.channelDeviceBrands = this.$store.state.Pusher.subscribe('e_x_c_m_device_brands')
    this.channelDeviceBrands.bind('e_x_c_m_device_brands', data => {
      this.getDeviceBrands()
    })
    this.getDeviceTypes()
    this.channelDeviceTypes = this.$store.state.Pusher.subscribe('e_x_c_m_device_types')
    this.channelDeviceTypes.bind('e_x_c_m_device_types', data => {
      this.getDeviceTypes()
    })
  },

  methods: {
    addNewDeviceType () {
      this.$store.state.modals.excmdevicetype.form.show = 1
    },
    addNewDeviceBrand () {
      this.$store.state.modals.excmdevicebrand.form.show = 1
    },
    closeModal () {
      this.$store.state.modals.excmdevicemodel.form.close = 1
    },
    getDeviceBrands () {
      let params = {
        'pagination': false
      }
      this.$http
        .get('api/e_x_c_m_device_brands', {
          params
        })
        .then(response => {
          this.deviceBrands = response.data['hydra:member']
        })
        .catch(error => {
          if (error.response.status === 400) {
            let text = ''
            for (let i in error.response.data) {
              text += error.response.data[i] + '\n'
            }
            this.$Swal({
              type: 'warning',
              title: text,
              timer: 2500
            })
          }
          console.log(error)
        })
    },
    getDeviceTypes () {
      let params = {
        'pagination': false
      }
      this.$http
        .get('api/e_x_c_m_device_types', {
          params
        })
        .then(response => {
          this.deviceTypes = response.data['hydra:member']
        })
        .catch(error => {
          if (error.response.status === 400) {
            let text = ''
            for (let i in error.response.data) {
              text += error.response.data[i] + '\n'
            }
            this.$Swal({
              type: 'warning',
              title: text,
              timer: 2500
            })
          }
          console.log(error)
        })
    },
    checkRoles (type, view = null, component = null) {
      return checkPermission(type, view, component)
    },
    isInvalid (key) {
      return Object.keys(this.violations).length > 0 && this.violations[key]
    }
  }
}
</script>
